export default {
  getPesquisasSatisfacao: state => state.pesquisasSatisfacao,
  getTags: state => state.tags,
  findPesquisaById: state => id => state.pesquisasSatisfacao.find(pesquisa => pesquisa._id === id),
}
